export enum OrderStatus {
  CREATED = 'CREATED',
  UPDATED = 'UPDATED',
  SUPPORTED = 'SUPPORTED',
  CREATION_IN_PROGRESS = 'CREATIONINPROGRESS',
  VALIDATED = 'VALIDATED',
  INACTIVE = 'INACTIVE',
  CANCELED = 'CANCELED',
  PREPARATION_STARTED = 'PREPARATION_STARTED',
  PREPARATION_FINISHED = 'PREPARATION_FINISHED',
  SHIPPED = 'SHIPPED',
}
